'use strict';

import _ from 'lodash';

import React from 'react';
import PropTypes from 'prop-types';
import Input from './Input';
import propIsVerifierInstance from 'ck-core/source/functions/propIsVerifierInstance';

export default class SelectInput extends React.Component {
	async validate(value) {
		let isValid;
		let error;

		if (this.props.optional && !value) {
			isValid = true;
		} else if (!this.props.validate) {
			isValid = !!value;
		} else {
			const result = await this.props.validate(value);
			isValid = _.get(result, 'valid', true);
			error = _.get(result, 'error');
		}

		if (this.props.onValidate) {
			this.props.onValidate(isValid, error);
		}
	}

	handleChangeValue(newValue) {
		if (this.props.onChange) {
			this.props.onChange(newValue);
		}

		this.validate(newValue);
	}

	handleChange(event) {
		const newValue = event.target.value;

		this.handleChangeValue(newValue);
	}

	componentDidMount() {
		if (_.isNil(this.props.value)) {
			if (!this.props.placeholder) {
				this.handleChangeValue(this.props.choices[0].key);
			}
		} else {
			// An initial value was provided, so validate it, which will allow
			// the parent form to know whether this input is valid already.
			this.validate(this.props.value);
		}
	}

	render() {
		return (
			<Input {...this.props} className="SelectInput">
				<select
					name={this.props.name}
					value={_.isNil(this.props.value) ? 'placeholder' : this.props.value}
					disabled={this.props.disabled}
					onChange={this.handleChange.bind(this)}
				>
					{this.props.placeholder && (
						<option disabled key="placeholder" value="placeholder">
							{this.props.placeholder}
						</option>
					)}
					{this.props.choices.map(choice => (
						<option key={choice.key} value={choice.key}>
							{choice.text}
						</option>
					))}
				</select>
			</Input>
		);
	}
}

SelectInput.defaultProps = {
	emptyValue: null
};

SelectInput.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	placeholder: PropTypes.string,
	disabled: PropTypes.bool,
	choices: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
			text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
		})
	).isRequired,
	onChange: PropTypes.func,
	onValidate: PropTypes.func,
	optional: PropTypes.bool,
	validate: PropTypes.oneOfType([PropTypes.func, propIsVerifierInstance])
};
